// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getPuntos as listPuntosAPI,
    getPunto as getPuntoAPI,
    addPunto as addPuntoAPI,
    updatePunto as updatePuntoAPI,
    deletePunto as deletePuntoAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { puntosApiResponseError, puntosApiResponseSuccess } from './actions';
import { PuntosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getPunto({ payload: { id } }) {
    try {
        const response = yield call(getPuntoAPI, id );
        const puntoItem = response.data.data;
        yield put(puntosApiResponseSuccess(PuntosActionTypes.GET_PUNTO, puntoItem));
    } catch (error) {
        yield put(puntosApiResponseError(PuntosActionTypes.GET_PUNTO, error));
    }
}

function* addPunto({payload:punto}){
    try{
        const response = yield call(addPuntoAPI,{...punto})
        const puntoItem = response.data
        yield put(puntosApiResponseSuccess(PuntosActionTypes.ADD_PUNTO,puntoItem))
    } catch(error){
        yield put(puntosApiResponseError(PuntosActionTypes.ADD_PUNTO,error))
    }
}

function* updatePunto({payload:punto}){
    try{
        const response = yield call(updatePuntoAPI,{...punto})
        const puntoItem = response.data.data
        yield put(puntosApiResponseSuccess(PuntosActionTypes.UPDATE_PUNTO,puntoItem))
    }catch(error){
        yield put(puntosApiResponseError(PuntosActionTypes.UPDATE_PUNTO,error))
    }
}
function* deletePunto({payload:{id}}){
    try{
        const response = yield call(deletePuntoAPI,id)
        const puntoItem = response.data.id
        yield put(puntosApiResponseSuccess(PuntosActionTypes.DELETE_PUNTO,puntoItem))
    }catch(error){
        yield put(puntosApiResponseError(PuntosActionTypes.DELETE_PUNTO,error))
    }
}

/**
 * List contactos
 */
function* listPuntos({payload:params}) {
    try {
        const response = yield call(listPuntosAPI, { ...params });
        const listaPuntos = response.data.data;
        yield put(puntosApiResponseSuccess(PuntosActionTypes.LIST_PUNTOS, listaPuntos));
    } catch (error) {
        yield put(puntosApiResponseError(PuntosActionTypes.LIST_PUNTOS, error));
    }
}


export function* watchGetPunto(): any {
    yield takeEvery(PuntosActionTypes.GET_PUNTO, getPunto);
}

export function* watchListPuntos(): any {
    yield takeEvery(PuntosActionTypes.LIST_PUNTOS, listPuntos);
}

export function* watchAddPunto():any{
    yield takeEvery(PuntosActionTypes.ADD_PUNTO,addPunto)
}
export function* watchUpdatePunto():any{
    yield takeEvery(PuntosActionTypes.UPDATE_PUNTO,updatePunto)
}
export function* watchDeletePunto():any{
    yield takeEvery(PuntosActionTypes.DELETE_PUNTO,deletePunto)
}


function* puntosSaga(): any {
    yield all([
        fork(watchGetPunto),
        fork(watchListPuntos),
        fork(watchAddPunto),
        fork(watchUpdatePunto),
        fork(watchDeletePunto),
    ]);
}

export default puntosSaga;
